<template>
    <div>
      <v-dialog v-model="dialog.dialogBrowseCustomer" max-width="800px" scrollable eager>
        <CustomerJobBrowse ref="CustomerJobBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </CustomerJobBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseProject" max-width="800px" scrollable eager>
        <ProjectBrowse ref="ProjectBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </ProjectBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseJob" max-width="800px" scrollable eager>
        <JobBrowse ref="JobBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </JobBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowsePersonInCharge" max-width="800px" scrollable eager>
        <CustomerIssueLogUserBrowse ref="CustomerIssueLogUserBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </CustomerIssueLogUserBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseAssigner" max-width="800px" scrollable eager>
        <CustomerIssueLogUserBrowse ref="AssignerBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </CustomerIssueLogUserBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseIssueLogID" max-width="800px" scrollable eager>
        <IssueLogIDBrowse ref="IssueLogIDBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </IssueLogIDBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseSupplier" max-width="800px" scrollable eager>
        <SupplierBrowse ref="SupplierBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </SupplierBrowse>
      </v-dialog>
      <v-toolbar scrollable color="light-blue darken-4" dark>
        <v-spacer></v-spacer>
        <!-- <v-btn ref = "buttonNew" color="primary" style="text-transform: capitalize" @click="newJob" :disabled="disabledControl.buttonNew">
          <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('new')}}
        </v-btn>
        <v-btn ref = "buttonDelete" color="primary" style="text-transform: capitalize" @click="deleteJob" :disabled="disabledControl.buttonDelete">
          <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('delete')}}
        </v-btn> -->
        <v-btn ref = "buttonSave" color="primary" style="text-transform: capitalize" @click="saveItemMaster" :disabled="disabledControl.buttonSave">
          <img src="../assets/SoftwareClinicIcon/Save.png" height="30" weight="30"/>{{$t('save')}}
        </v-btn>
        <!-- <v-btn ref = "buttonQuery" color="primary" style="text-transform: capitalize" @click="queryJob" :disabled="disabledControl.buttonQuery">
          <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>{{$t('query')}}
        </v-btn>
        <v-btn ref = "buttonFind" color="primary" style="text-transform: capitalize" @click="findJob" :disabled="disabledControl.buttonFind">
          <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
        </v-btn> -->
      </v-toolbar>
      <v-container grid-list-xs text-xs-center fluid>
        <v-row row wrap>
          <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
            <v-text-field label="Item Number" v-model="resourceData.resource_no" ref="textFieldResourceNo" :readonly="readOnlyControl.textFieldResourceNo" outlined dense hide-details></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
            <v-text-field label="Description" v-model="resourceData.description" outlined dense hide-details></v-text-field>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col cols="12" xs="12" md="6">
            <v-select :items="dropDownData.item_status" v-model="resourceData.restrict_code" item-text="description" item-value="code" label="Status" 
                          persistent-hint outlined dense hide-details>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field label="Addition Description" v-model="resourceData.addition_desc" outlined dense hide-details></v-text-field>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col cols="12" xs="12" md="4">
            <v-select :items="dropDownData.uom" v-model="resourceData.uom" item-text="uom_desc" item-value="uom" label="UOM" 
                          persistent-hint outlined dense hide-details>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select :items="dropDownData.inventory_type" v-model="resourceData.resource_type" item-text="description" item-value="code" label="Inventory Type" 
                          persistent-hint outlined dense hide-details>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select :items="dropDownData.item_catagory" v-model="resourceData.item_catagory_cd" item-text="item_catagory_desc" item-value="item_catagory_cd" label="Item Catagory" 
                          persistent-hint outlined dense hide-details>
            </v-select>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col cols="12" sm="12" md="4">
            <v-select :items="dropDownData.product_group" v-model="resourceData.product_class" item-text="description" item-value="product_class" label="Product Group" 
                          persistent-hint outlined dense hide-details>
              </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select :items="dropDownData.product_line" v-model="resourceData.product_line_code" item-text="description" item-value="product_line_code" label="Product Line" 
                          persistent-hint outlined dense hide-details>
              </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select :items="dropDownData.commodity" v-model="resourceData.commodity" item-text="description" item-value="commodity" label="Commodity" 
                          persistent-hint outlined dense hide-details>
              </v-select>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col cols="12" sm="12" md="4">
              <v-select :items="dropDownData.location" v-model="resourceData.home_location" item-text="description" item-value="location" label="Home Location" 
                          persistent-hint outlined dense hide-details>
              </v-select>
          </v-col>
          <v-col cols="12" xs="12" md="4">
            <v-text-field label="Shelf Life" v-model="resourceData.shelf_life" outlined dense hide-details></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    <v-tabs center-active dark>
      <v-tab style="text-transform: capitalize"> Vendor Ranking </v-tab>
        <v-tab-item eager>
        <v-data-table
          v-model="vDataTable.selected"
          :headers="headers"
          :items="vDataTable.data"
          :search="vDataTable.search"
          show-select
          fixed-header
          :page.sync="vDataTable.options.page"
          :itemsPerPage.sync="vDataTable.options.itemsPerPage"
          :options.sync="vDataTable.options"
          :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="vendor_skey"
          class="fill-height">
          <template v-slot:header.win_name="{ header }">
              {{ header.text.toUpperCase() }}
          </template>
          <template v-slot:header.data-table-select="{ on, props }">
            <tr>
              <td>
                <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
              </td>
              <td v-if="vDataTable.selected.length > 0">
                {{vDataTable.selected.length}}
              </td>
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog.dialogAddEdit" max-width="500px" eager>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                    <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">  
                          <v-text-field label="Ranking" v-model="vDataTable.editedItem.ranking" type="number" outlined dense hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field label="Supplier" v-model="vDataTable.editedItem.vendor_name"
                            outlined dense hide-details readonly
                            @click:clear="clearPersonInCharge"
                            clearable>
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" color="blue" @click="browseSupplier">mdi-file-find</v-icon>
                                </template>
                                Search Supplier
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                      <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer></v-spacer>
              <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
            </v-toolbar>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
          <template v-slot:item.data-table-no="{ item, index }">
            {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
          </template>
          <template v-slot:no-data>
            <v-alert type="info">
              {{$t('noData')}}
            </v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert type="warning">
              {{stringFormat($t('searchNotFound'),vDataTable.search)}}
            </v-alert>
          </template>
          <template v-slot:footer>
            <tr class="sticky-table-footer" style="position: absolute">
              <td>Selected({{vDataTable.selected.length}})s</td> 
            </tr>
          </template>
        </v-data-table> 
    </v-tab-item>
      <v-tab style="text-transform: capitalize"> Resource File </v-tab>
      <v-tab-item eager>
        <v-data-table
          v-model="vDataTableResourceFile.selected"
          :headers="headersResourceFile"
          :items="vDataTableResourceFile.data"
          :search="vDataTableResourceFile.search"
          show-select
          fixed-header
          :page.sync="vDataTableResourceFile.options.page"
          :itemsPerPage.sync="vDataTableResourceFile.options.itemsPerPage"
          :options.sync="vDataTableResourceFile.options"
          :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="file_name"
          class="fill-height">
          <template v-slot:header.win_name="{ header }">
              {{ header.text.toUpperCase() }}
          </template>
          <template v-slot:header.data-table-select="{ on, props }">
            <tr>
              <td>
                <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
              </td>
              <td v-if="vDataTableResourceFile.selected.length > 0">
                {{vDataTableResourceFile.selected.length}}
              </td>
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog.dialogAddEditResourceFile" max-width="500px" eager>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                    <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitleResourceFile }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field label="Filename" v-model="vDataTableResourceFile.editedItem.file_name" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">  
                          <v-text-field label="File Path" v-model="vDataTableResourceFile.editedItem.file_path" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <div v-if="vDataTableResourceFile.editedIndex === -1">
                          <v-btn outlined color="primary" style="text-transform: capitalize" @click="Browsefile()">
                            upload
                          </v-btn>
                        </div>
                          <v-file-input style="display: none"
                            ref="fileInput"
                            align="center" justify="center" dense flat outlined hide-details hide-input
                            accept=".jpg,.png"
                            @change="handleFileChange"
                            >
                          </v-file-input>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">  
                          <v-text-field label="Description" v-model="vDataTableResourceFile.editedItem.description" outlined dense hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">  
                          <v-text-field label="Remark" v-model="vDataTableResourceFile.editedItem.remark" outlined dense hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">  
                          <v-text-field label="Additional Desc" v-model="vDataTableResourceFile.editedItem.additional_desc" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="closeResourceFile">{{$t('cancel')}}</v-btn>
                      <v-btn outlined color="primary" @click="saveResourceFile">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-divider class="mx-1" inset vertical></v-divider>
              <v-btn outlined color="primary" @click="checkDeleteResourceFileselected" style="text-transform: capitalize">
                <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
              </v-btn>
              <v-divider class="mx-1" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="vDataTableResourceFile.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
            </v-toolbar>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItemResourceFile(item)">edit</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirmResourceFile(item)">delete</v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
          <template v-slot:item.data-table-no="{ item, index }">
            {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
          </template>
          <template v-slot:no-data>
            <v-alert type="info">
              {{$t('noData')}}
            </v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert type="warning">
              {{stringFormat($t('searchNotFound'),vDataTable.search)}}
            </v-alert>
          </template>
          <template v-slot:footer>
            <tr class="sticky-table-footer" style="position: absolute">
              <td>Selected({{vDataTable.selected.length}})s</td> 
            </tr>
          </template>
        </v-data-table> 
      </v-tab-item>
    </v-tabs> 
    </div>
  </template>
  <script>
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import CustomerJobBrowse from '@/components/common/CustomerJobBrowse'
  import CustomerIssueLogUserBrowse from '@/components/common/CustomerIssueLogUserBrowse'
  import ProjectBrowse from '@/components/common/ProjectBrowse'
  import JobBrowse from '@/components/common/JobBrowse'
  import IssueLogIDBrowse from '@/components/common/IssueLogIDBrowse'
  import SupplierBrowse from '@/components/common/SupplierBrowse'
  
  export default {
    components: {
      CustomerJobBrowse,
      CustomerIssueLogUserBrowse,
      ProjectBrowse,
      JobBrowse,
      IssueLogIDBrowse,
      SupplierBrowse
    },
  
    props: ['parentComponent'],
  
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        appName: process.env.VUE_APP_DB_APP_NAME,
        dialog: {
          dialogProgress: false,
          dialogAddEdit: false,
          dialogCriteria: false,
          dialogBrowseCustomer: false,
          dialogBrowseProject: false,
          dialogBrowseJob: false,
          dialogBrowsePersonInCharge: false,
          dialogBrowseAssigner: false,
          dialogBrowseIssueLogID: false,
          dialogBrowseSupplier: false,
          dialogAddEditResourceFile: false,
          dialogUpload: false,
        },
        stateWindow: '',
        readOnlyControl: {
          textFieldResourceNo: false,
        },
        disabledControl: {
          buttonNew: false,
          buttonDelete: false,
          buttonSave: false,
          buttonQuery: false,
          buttonFind: false,
          buttonSaveDetail: false,
        },
        menu: {
          menuStartDate: false,
          menuDueDate: false,
          menuCompleteDate: false,
          menuAssignDate: false,
        },
        resourceData: [],
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
        vDataTableResourceFile: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
        sendVar: [],
        dropDownData: [],
        progressMessage: '',
        criteria: {
          requestDateFromTo: [],
          createdDateFromTo: [],
          status: '',
          custSkey: -1,
          custName: '',
          personInCharge: '',
          personInChargeName: '',
        },
        MethodStatus: '',
      }
    },
  
    computed: {
      ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
      ...mapState({
        userID: state => `${state.user.profile.user_id}`,
        userFullName: state => `${state.user.profile.user_fullname}`,
      }),
      dateRangeTextRequestDateFromTo () {
        return this.criteria.requestDateFromTo.join(' ~ ')
      },
      dateRangeTextCreatedDateFromTo () {
        return this.criteria.createdDateFromTo.join(' ~ ')
      },
      formTitle () {
        return this.vDataTable.editedIndex === -1 ? 'New Supplier Ranking' : 'Edit Supplier Ranking'
      },
      formTitleResourceFile () {
        return this.vDataTableResourceFile.editedIndex === -1 ? 'New Resource File' : 'Edit Resource File'
      },
      headers () {
        return [
          { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
          { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
          { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
          { text: 'ranking', align: 'left', value: 'ranking', class: 'text-xl-left body-1 black--text' },
          { text: 'vendor', align: 'left', value: 'vendor', class: 'text-xl-left body-1 black--text' },
          { text: 'vendor_name', align: 'left', value: 'vendor_name', class: 'text-xl-left body-1 black--text' },
        ]
      },
      headersResourceFile () {
        return [
          { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
          { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
          { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
          { text: 'file_name', align: 'left', value: 'file_name', class: 'text-xl-left body-1 black--text' },
          { text: 'file_path', align: 'left', value: 'file_path', class: 'text-xl-left body-1 black--text' },
          { text: 'description', align: 'left', value: 'description', class: 'text-xl-left body-1 black--text' },
          { text: 'remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
          { text: 'additional_desc', align: 'left', value: 'additional_desc', class: 'text-xl-left body-1 black--text' },
          { text: 'date_created', align: 'left', value: 'date_created', class: 'text-xl-left body-1 black--text' },
          { text: 'user_created', align: 'left', value: 'user_created', class: 'text-xl-left body-1 black--text' },
          { text: 'date_changed', align: 'left', value: 'date_created', class: 'text-xl-left body-1 black--text' },
          { text: 'user_changed', align: 'left', value: 'user_changed', class: 'text-xl-left body-1 black--text' },
        ]
      },
      offsetAppBar () {
        return this.getShowAppBar ? this.getAppBarHeight : 0
      }
    },
  
    watch: {
      'dialog.dialogAddEdit' (val) {
        val || this.close()
      },
      stateWindow: function (after, before) {
        try {
          switch (after) {
            case 'NewState':
              this.disabledControl.buttonNew = false
              this.disabledControl.buttonDelete = true
              this.disabledControl.buttonSave = false
              this.disabledControl.buttonQuery = false
              this.disabledControl.buttonFind = true
              this.readOnlyControl.textFieldResourceNo = false
              this.$refs.textFieldResourceNo.focus()
              break
            case 'DeleteState':
              this.disabledControl.buttonNew = false
              this.disabledControl.buttonDelete = true
              this.disabledControl.buttonSave = false
              this.disabledControl.buttonQuery = false
              this.disabledControl.buttonFind = true
              break
            case 'SaveState':
              this.disabledControl.buttonNew = false
              this.disabledControl.buttonDelete = false
              this.disabledControl.buttonSave = false
              this.disabledControl.buttonQuery = false
              this.disabledControl.buttonFind = false
              break
            case 'QueryState':
              this.disabledControl.buttonNew = false
              this.disabledControl.buttonDelete = true
              this.disabledControl.buttonSave = true
              this.disabledControl.buttonQuery = false
              this.disabledControl.buttonFind = false
              this.readOnlyControl.textFieldResourceNo = false
              this.$refs.textFieldResourceNo.focus()
              break
            case 'FindState':
              this.disabledControl.buttonNew = false
              this.disabledControl.buttonDelete = false
              this.disabledControl.buttonSave = false
              this.disabledControl.buttonQuery = false
              this.disabledControl.buttonFind = false
              this.readOnlyControl.textFieldResourceNo = true
              break
          }
        } catch (e) {
          this.$swal({type: 'error', title: e.message})
        }
      },
    },
  
    async created () {
      this.retrieveDropDown()
      if (localStorage.getItem('resourceNo') !== undefined && localStorage.getItem('resourceNo') !== null) {
        this.retrieveItemMaster(localStorage.getItem('resourceNo'))
        this.retrieveItemVendor(localStorage.getItem('resourceNo'))
        this.retrieveResourceFile(localStorage.getItem('resourceNo'))
        if (localStorage.getItem('resourceNo').length > 0) {
          this.stateWindow = 'FindState'
          this.MethodStatus = 'Update'
        } else {
          this.stateWindow = 'NewState'
          this.MethodStatus = 'Insert'
        }
        localStorage.removeItem('resourceNo')
      } else {
        this.stateWindow = 'QueryState'
      }
    },
  
    mounted () {
    },
  
    updated () {
    },
  
    methods: {
      selectLanguage (language) {
      },
      getVarReturn (value) {
        switch (value.childSend) {
          case 'CustomerJobBrowse':
            this.dialog.dialogBrowseCustomer = false
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseCustomer':
                    this.resourceData.cust_skey = value.dataSelected[0]['cust_skey']
                    this.resourceData.cust_name = value.dataSelected[0]['cust_name']
                    break
                }
            }
            break
          case 'ProjectBrowse':
            this.dialog.dialogBrowseProject = false
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseProject':
                    this.resourceData.proj_cd = value.dataSelected[0]['proj_cd']
                    this.resourceData.proj_desc = value.dataSelected[0]['proj_desc']
                    break
                }
            }
            break
          case 'JobBrowse':
            this.dialog.dialogBrowseJob = false
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseJob':
                    this.retrieveItemMaster(value.dataSelected[0]['job_id'])
                    break
                }
            }
            break
          case 'CustomerIssueLogUserBrowse':
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browsePersonInCharge':
                    this.resourceData.person_in_charge = value.dataSelected[0]['user_id']
                    this.resourceData.person_in_charge_name = value.dataSelected[0]['fullname']
                    this.dialog.dialogBrowsePersonInCharge = false
                    break
                  case 'browseAssigner':
                    this.resourceData.assigner = value.dataSelected[0]['user_id']
                    this.resourceData.assigner_name = value.dataSelected[0]['fullname']
                    this.dialog.dialogBrowseAssigner = false
                    break
                }
                break
              default:
                switch (value.browseName) {
                  case 'browsePersonInCharge':
                    this.dialog.dialogBrowsePersonInCharge = false
                    break
                  case 'browseAssigner':
                    this.dialog.dialogBrowseAssigner = false
                    break
                }
            }
            break
          case 'IssueLogIDBrowse':
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseIssueLogID':
                    this.resourceData.issue_log_id = value.dataSelected[0]['issue_log_id']
                    this.dialog.dialogBrowseIssueLogID = false
                    break
                }
                break
              default:
                switch (value.browseName) {
                  case 'browseIssueLogID':
                    this.dialog.dialogBrowseIssueLogID = false
                    break
                }
            }
            break
          case 'SupplierBrowse':
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseSupplier':
                    this.vDataTable.editedItem.vendor_skey = value.dataSelected[0]['vendor_skey']
                    this.vDataTable.editedItem.vendor = value.dataSelected[0]['vendor']
                    this.vDataTable.editedItem.vendor_name = value.dataSelected[0]['vendor_name']
                    this.dialog.dialogBrowseSupplier = false
                    break
                }
                break
              default:
                switch (value.browseName) {
                  case 'browseSupplier':
                    this.dialog.dialogBrowseSupplier = false
                    break
                }
            }
            break
        }
      },
      initialize () {
        this.vDataTable.selected = []
        this.vDataTable.editedIndex = -1
        this.vDataTable.editedItem = {
          win_name: '',
          window_comment: ''
        }
        this.vDataTable.defaultItem = {
          win_name: '',
          window_comment: ''
        }
      },
      Browsefile () {
        if (this.MethodStatus === 'Insert') {
          alert('กรุณา save item ก่อนจะ browse file')
          return
        }
        if (this.vDataTableResourceFile.editedIndex === -1) {
          this.vDataTableResourceFile.editedItem.resource_no = this.resourceData.resource_no
        }
        this.$refs.fileInput.$refs.input.click()
      },
      async handleFileChange (file) {
        this.dialog.dialogUpload = true
        if (file) {
          try {
            this.progressMessage = 'file uploading... ' + file.name
            const base64String = await this.readFileAsync(file)
            file.base64String = base64String
            await this.uploadFile(file)
          } catch (error) {
            this.$swal({type: 'error', title: error})
          }
        } else {
          this.$swal({type: 'error', title: 'No file selected'})
        }
        this.dialog.dialogUpload = false
      },
      readFileAsync (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()

          reader.onload = function (event) {
            resolve(window.btoa(event.target.result))
          }

          reader.onerror = function (error) {
            reject(error)
          }

          reader.readAsBinaryString(file)
        })
      },
      async uploadFile (file) {
        var msg = ''
        this.uploadPercentage = 0
        // this.clearUploadFileData()
        let formData = new FormData()
        formData.append('resource_no', this.vDataTableResourceFile.editedItem.resource_no)
        let fileExtension = file.name.split('.').pop()
        formData.append('filename', file.name)
        formData.append('base64String', file.base64String)
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/uploadFile' + process.env.VUE_APP_DATABASE_TYPE, formData,
          {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: function (progressEvent) {
              this.dialog.dialogUpload = false
              this.uploadPercentage = 100
            }.bind(this)
          }
        ).then(async response => {
          if (response.data.isSuccess) {
            this.vDataTableResourceFile.editedItem.file_name = file.name
            this.vDataTableResourceFile.editedItem.file_path = response.data.data.file_path
            this.dialog.dialogAddEditResourceFile = false
            this.dialog.dialogAddEditResourceFile = true
          } else {
            msg = msg + response.data.reasonText + '<br>'
          }
        })
        .catch(async e => {
          msg = msg + response.data.reasonText + '<br>'
        })
        if (msg) {
          this.$swal({type: 'error', title: msg, showConfirmButton: true})
        }
      },
      openDialogCriteria () {
        this.dialog.dialogCriteria = true
      },
      browseCustomer () {
        this.dialog.dialogBrowseCustomer = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseCustomer'
        this.$refs.CustomerJobBrowse.retrieveCustomer()
      },
      browseCustomerCriteria () {
        this.dialog.dialogBrowseCustomer = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseCustomerCriteria'
        this.$refs.CustomerJobBrowse.retrieveCustomer()
      },
      browsePersonInCharge () {
        this.dialog.dialogBrowsePersonInCharge = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browsePersonInCharge'
        this.$refs.CustomerIssueLogUserBrowse.retrieveUser()
      },
      browseProject () {
        this.dialog.dialogBrowseProject = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseProject'
        this.$refs.ProjectBrowse.retrieveProject()
      },
      browseAssigner () {
        this.dialog.dialogBrowseAssigner = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseAssigner'
        this.$refs.AssignerBrowse.retrieveUser()
      },
      browseSupplier () {
        this.dialog.dialogBrowseSupplier = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseSupplier'
        this.$refs.SupplierBrowse.retrieveSupplier()
      },
      clearAssigner () {
        this.resourceData.assigner = ''
        this.resourceData.assigner_name = ''
      },
      browseIssueLogID () {
        this.dialog.dialogBrowseIssueLogID = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseIssueLogID'
        this.$refs.IssueLogIDBrowse.retrieveIssueLogID()
      },
      clearIssueLogID () {
        this.resourceData.issue_log_id = ''
      },
      clearCustomer () {
        this.resourceData.cust_skey = -1
        this.resourceData.cust_name = ''
      },
      clearCustomerCriteria () {
        this.resourceData.custSkey = -1
        this.resourceData.custName = ''
      },
      clearPersonInCharge () {
        this.resourceData.person_in_charge = ''
        this.resourceData.person_in_charge_name = ''
      },
      clearProject () {
        this.resourceData.proj_cd = ''
        this.resourceData.proj_desc = ''
      },
      clearAll () {
        this.criteria.requestDateFromTo = []
        this.criteria.createdDateFromTo = []
        this.criteria.status = ''
        this.criteria.custSkey = -1
        this.criteria.custName = ''
        this.criteria.personInCharge = ''
        this.criteria.personInChargeName = ''
      },
      changeStatus (e) {
        if (e === 'CO') {
          this.vDataTable.editedItem.complete_date = this.utils.getCurrentDateStr()
          this.vDataTable.editedItem.pct_progress = 100
        }
      },
      changePostponeType (e) {
        let foundArr = this.dropDownData.postpone_type.filter(x => x.code === e)
        if (foundArr.length > 0) {
          this.vDataTable.editedItem.postpone_type_desc = foundArr[0].description
        }
      },
      async newJob () {
        await this.retrieveItemMaster('')
        this.stateWindow = 'NewState'
        this.readOnlyLabOrder = false
        this.resourceData.status = 'OP'
        this.resourceData.urgent = false
        this.resourceData.person_in_charge = this.userID
        this.resourceData.person_in_charge_name = this.userFullName
        this.resourceData.assigner = this.userID
        this.resourceData.assigner_name = this.userFullName
        this.resourceData.assign_date = this.utils.getCurrentDateStr()
      },
      async deleteJob () {
        await this.axios.post(process.env.VUE_APP_API + '/job/deleteJob' + process.env.VUE_APP_DATABASE_TYPE, {
          job_id: this.resourceData.job_id,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: response.data.reasonText})
              await this.retrieveItemMaster('')
              this.stateWindow = 'QueryState'
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
      },
      async saveItemMaster () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/saveitemMaster' + process.env.VUE_APP_DATABASE_TYPE, {
          item_master: this.resourceData,
          method_status: this.MethodStatus,
          item_vend: this.vDataTable.data
        })
          .then(async response => {
            if (response.data.isSuccess) {
              this.MethodStatus = 'Update'
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
        this.stateWindow = 'SaveState'
      },
      async queryJob () {
        await this.retrieveItemMaster('')
        this.stateWindow = 'QueryState'
      },
      async findJob () {
        var jobID = this.$refs.textFieldResourceNo.value
        if (jobID === undefined || jobID.length === 0) {
          this.dialog.dialogBrowseJob = true
          this.sendVar.singleSelect = true
          this.sendVar.browseName = 'browseJob'
          this.$refs.JobBrowse.retrieveItemMaster()
          this.stateWindow = 'FindState'
        } else {
          await this.retrieveItemMaster(jobID)
          this.stateWindow = 'FindState'
          if (this.$refs.textFieldResourceNo.value === undefined || this.$refs.textFieldResourceNo.value.length === 0) {
            var format = require('string-format')
            await this.$swal({type: 'error', title: format('Not Found Job ID ({})', jobID)})
          }
        }
      },
      newJobDetail () {
        // let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        // alert(new Date().toLocaleString('en-US', { timeZone: timeZone }))
        // this.vDataTable.editedItem.request_date = new Date().toJSON().slice(0, 10)
        // this.vDataTable.editedItem.request_date = this.utils.getCurrentDateStr()
        this.vDataTable.editedItem.job_detail_skey = -1
        this.vDataTable.editedItem.job_id = this.resourceData.job_id
        this.vDataTable.editedItem.status = 'OP'
        this.vDataTable.editedItem.postpone_type = 'O'
        let foundArr = this.dropDownData.postpone_type.filter(x => x.code === 'O')
        if (foundArr.length > 0) {
          this.vDataTable.editedItem.postpone_type_desc = foundArr[0].description
        }
  
        if (this.resourceData.job_id.length === 0) {
          this.$swal({type: 'error', title: 'กรุณาเลือก Job ก่อนจะเพิ่มข้อมูล'})
          this.disabledControl.buttonSaveDetail = true
        } else {
          this.disabledControl.buttonSaveDetail = false
        }
      },
      async retrieveItemMaster (resourceNo) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/retrieveItemMaster' + process.env.VUE_APP_DATABASE_TYPE, {
          'resource_no': resourceNo,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.resourceData = response.data.data[0]
              if (this.resourceData === undefined) {
                this.resourceData = {}
              }
              this.initialize()
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
        this.dialog.dialogCriteria = false
      },
      async retrieveItemVendor (resourceNo) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/retrieveItemVendor' + process.env.VUE_APP_DATABASE_TYPE, {
          'resource_no': resourceNo,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
        this.dialog.dialogCriteria = false
      },
      async retrieveResourceFile (resourceNo) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/retrieveResourceFile' + process.env.VUE_APP_DATABASE_TYPE, {
          'resource_no': resourceNo,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTableResourceFile.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
        this.dialog.dialogCriteria = false
      },
      retrieveDropDown () {
        this.axios.post(process.env.VUE_APP_API + '/itemMaster/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.dropDownData = response.data.data[0]
              console.log(this.dropDownData)
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      async addCustomerIssueLog (data) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/customerIssueLog/addCustomerIssueLog' + process.env.VUE_APP_DATABASE_TYPE, {
          data: data
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.editedItem.issue_log_id = response.data.data.issue_log_id
              this.vDataTable.editedItem.date_created = response.data.data.date_created
              this.vDataTable.editedItem.user_created = response.data.data.user_created
              this.vDataTable.editedItem.date_changed = response.data.data.date_changed
              this.vDataTable.editedItem.user_changed = response.data.data.user_changed
              this.vDataTable.data.push(this.vDataTable.editedItem)
              this.close()
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async updateCustomerIssueLog (data) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/customerIssueLog/updateCustomerIssueLog' + process.env.VUE_APP_DATABASE_TYPE, {
          data: data
        })
          .then(response => {
            if (response.data.isSuccess) {
              Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
              this.vDataTable.data[this.vDataTable.editedIndex].date_changed = response.data.data.date_changed
              this.vDataTable.data[this.vDataTable.editedIndex].user_changed = response.data.data.user_changed
              this.close()
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      checkDeleteselected () {
        if (this.vDataTable.selected.length > 0) {
          this.$swal({
            text: 'Are you sure you want to delete selected Job Detail?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.deleteSelected()
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'Please select Job Detail to delete'})
        }
      },
      async deleteSelected () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
  
        var del = []
  
        await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
          this.progressMessage = this.stringFormat('Deleting Job Detail {}', x.job_detail_skey)
          var val = await this.deleteJobDetail(x)
  
          if (val !== undefined) {
            del.push(val)
          }
        }.bind(this))
  
        // del.forEach(x => {
        //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
        // })
  
        for (const x in del) {
          this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
        }
  
        this.dialog.dialogProgress = false
        // this.retrieveWindow(this.appName)
      },
      async deleteJobDetail (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var jobDetailSkey = item.job_detail_skey
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/job/deleteJobDetail' + process.env.VUE_APP_DATABASE_TYPE, {
            job_detail_skey: jobDetailSkey
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.vDataTable.data.indexOf(item) >= 0) {
                  this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      editItem (item) {
        this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
        this.vDataTable.editedItem = Object.assign({}, item)
        this.dialog.dialogAddEdit = true
      },
      editItemResourceFile (item) {
        this.vDataTableResourceFile.editedIndex = this.vDataTableResourceFile.data.indexOf(item)
        this.vDataTableResourceFile.editedItem = Object.assign({}, item)
        this.dialog.dialogAddEditResourceFile = true
      },
      async deleteItemConfirm (item) {
        if (this.vDataTable.data.indexOf(item) >= 0) {
          this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
        }
      },
      checkDeleteResourceFileselected () {
        if (this.vDataTableResourceFile.selected.length > 0) {
          this.$swal({
            text: 'คุณต้องการที่จะลบข้อมูลหรือไหม?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.deleteResourceFileSelected()
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'กรุณาเลือก file ที่จะลบ'})
        }
      },
      async deleteResourceFileSelected () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')

        var del = []

        await this.utils.asyncForEach(this.vDataTableResourceFile.selected, async function (x) {
          this.progressMessage = this.stringFormat(this.$t('navWindow.progressMessageDelete'), x.win_name)
          var val = await this.deleteResourceFile(x)

          if (val !== undefined) {
            del.push(val)
          }
        }.bind(this))

        // del.forEach(x => {
        //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
        // })

        for (const x in del) {
          this.vDataTableResourceFile.selected.splice(this.vDataTableResourceFile.selected.indexOf(x), 1)
        }

        this.dialog.dialogProgress = false
        // this.retrieveWindow(this.appName)
      },
      async deleteResourceFile (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/itemMaster/deleteResourceFile' + process.env.VUE_APP_DATABASE_TYPE, {
            resource_file: item
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.vDataTableResourceFile.data.indexOf(item) >= 0) {
                  this.vDataTableResourceFile.data.splice(this.vDataTableResourceFile.data.indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      async deleteItemConfirmResourceFile (item) {
        this.$swal({
          text: this.stringFormat('คุณต้องการที่จะลบ file {}', item.file_name),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            // var val = await this.deleteWindow(this.vDataTable.editedItem)
            var val = await this.deleteResourceFile(item)
            if (val !== undefined) {
              if (this.vDataTableResourceFile.selected.indexOf(item) >= 0) {
                this.vDataTableResourceFile.selected.splice(this.vDataTableResourceFile.selected.indexOf(item), 1)
              }
            }
            // this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
            // this.vDataTable.editedIndex = -1
          }
        })
      },
      close () {
        this.dialog.dialogAddEdit = false
        this.$nextTick(() => {
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        })
      },
      closeResourceFile () {
        this.dialog.dialogAddEditResourceFile = false
        this.$nextTick(() => {
          this.vDataTableResourceFile.editedItem = Object.assign({}, this.vDataTableResourceFile.defaultItem)
          this.vDataTableResourceFile.editedIndex = -1
        })
      },
      async save () {
        if (this.resourceData.resource_no === undefined) {
          this.$swal({type: 'error', title: 'กรุณาใส่ Item Number'})
          return
        }
        if (this.vDataTable.editedItem.ranking === undefined) {
          this.$swal({type: 'error', title: 'กรุณาใส่ ranking'})
          return
        }
        if (this.vDataTable.editedItem.vendor_skey === undefined) {
          this.$swal({type: 'error', title: 'กรุณาใส่ Supplier'})
          return
        }
        this.vDataTable.editedItem.resource_no = this.resourceData.resource_no
        if (this.vDataTable.editedIndex > -1) {
          Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
          this.close()
        } else {
          this.vDataTable.data.push(this.vDataTable.editedItem)
          this.close()
        }
      },
      async addResourceFile (resourceFile) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/addResourceFile' + process.env.VUE_APP_DATABASE_TYPE, {
          resource_file: resourceFile,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTableResourceFile.data.push(this.vDataTableResourceFile.editedItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async updateResourceFile (resourceFile) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/itemMaster/updateResourceFile' + process.env.VUE_APP_DATABASE_TYPE, {
          resource_file: resourceFile,
        })
          .then(response => {
            if (response.data.isSuccess) {
              Object.assign(this.vDataTableResourceFile.data[this.vDataTableResourceFile.editedIndex], this.vDataTableResourceFile.editedItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async saveResourceFile () {
        if (this.MethodStatus === 'Insert') {
          alert('กรุณา save item ก่อนจะ save file')
          return
        }
        if (this.vDataTableResourceFile.editedItem.file_name === undefined) {
          this.$swal({type: 'error', title: 'กรุณาใส่ file name'})
          return
        }

        if (this.vDataTableResourceFile.editedIndex > -1) {
          await this.updateResourceFile(this.vDataTableResourceFile.editedItem)
        } else {
          this.vDataTableResourceFile.editedItem.resource_no = this.resourceData.resource_no
          await this.addResourceFile(this.vDataTableResourceFile.editedItem)
        }
        this.closeResourceFile()
      }
    },
  }
  </script>
  <style scoped>
  .sticky-table-footer td {
    font-weight: bold;
    position: sticky;
    bottom: 0;
    background-color: #f8f8f8;
    border-top: thin solid rgba(0,0,0,.12);
  }
  </style>